import React, { useEffect } from "react";
import { Divider, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { myOrderList } from "../../../Services/Orders";
import { ArrowBack, ArrowForwardIos } from "@mui/icons-material";
import { useState } from "react";

import OrderDetail from "./OrderDetail";

const MyOrders = () => {
  const [state, setState] = useState(false);
  const [orderId, setOrderId] = useState(null);

  const handleOpen = (id) => {
    setState(true);
    setOrderId(id);
  };

  const navigate = useNavigate();
  const { data: myOrders, isLoading } = useQuery(
    ["myOrderList"],
    () => myOrderList(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className="fixed h-16 z-50 flex items-center gap-5 bg-white dark:bg-zinc-900 py-4 px-2 shadow w-full">
        <ArrowBack onClick={() => navigate(-1)} />
        <p className="font-semibold text-lg">My Orders</p>
      </div>

      <Divider />
      <div className="bg-zinc-200 dark:bg-zinc-700 px-2 py-[70px] min-h-[94vh] flex flex-col gap-2 w-full">
        {isLoading
          ? [0, 1, 2, 3, 4, 5, 6].map(() => {
            return (
              <div className="flex flex-col gap-4 px-5 p-4 bg-white dark:bg-zinc-900 rounded-lg w-full">
                <Skeleton height={10} className="!scale-100 !w-11/12" />
                <Skeleton height={10} className="!scale-100 !w-11/12" />
                <Skeleton height={10} className="!scale-100 !w-11/12" />
              </div>
            );
          })
          : myOrders?.data?.data?.map((item) => {
            return (
              <>
                <div
                  className="flex justify-between items-center gap-5 px-5 p-2 bg-white dark:bg-zinc-900 rounded-lg w-full"
                  onClick={() => {
                    handleOpen(item.id);
                  }}
                >
                  <div className="flex flex-col text-sm">
                    <p> Order ID : #{item.orderid_id}</p>
                    <p>
                      Order Date :{" "}
                      {item.order_date.slice(0, 19).replace("T", " at : ")}
                    </p>
                    <p> Order Status : {item.order_status}</p>


                  </div>

                  <div className=" flex flex-col items-center  justify-between">
                    <ArrowForwardIos fontSize="20" />



                  </div>


                </div>
                {item?.porter_tracking_url.trim() && <button onClick={() => navigate("/track-order", {
                  state: {
                    porter_tracking_url: item?.porter_tracking_url
                  }
                })} className="text-xs  font-semibold  bg-blue-600  rounded-xl  text-white p-1">Track Order</button>}
              </>
            );
          })}
        <OrderDetail setState={setState} state={state} OrderId={orderId} />
      </div>
    </>
  );
};
export default MyOrders;
